import {columnsFn} from './utils';
import i18n from 'src/i18n/index';

export const columns = columnsFn({
  name: {type: 'string'},
  last_name: {type: 'string'},
  first_name: {type: 'string'},
  mobile: {type: 'string'},
  // "relationship": {type: 'string'},
});

export function title(model) {
  return model ? i18n.nn`${model.last_name} ${model.first_name} ${model.name} (${model.mobile})` : '';
}



// WEBPACK FOOTER //
// ./src/schemas/emergency_contact.js